import { render, staticRenderFns } from "./modal-up-selling.vue?vue&type=template&id=420dcceb&scoped=true&"
import script from "./modal-up-selling.vue?vue&type=script&lang=js&"
export * from "./modal-up-selling.vue?vue&type=script&lang=js&"
import style0 from "./modal-up-selling.vue?vue&type=style&index=0&id=420dcceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420dcceb",
  null
  
)

export default component.exports